import React from "react";
import { Container, Row } from "reactstrap";
import SoarIntegrationsTable from "./IntegrationsTable";

const Integrations = () => {
  document.title = "Dashboard | Risknox";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
           <Row>
             <SoarIntegrationsTable />
           </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Integrations;
